import { toPairs } from 'lodash/fp';

/**
 * "features": {
      "myPersonalMagicalFeature": {
        "not": {"allowLocales": ["de", "es", "nl"], "afterTime": '12.12.2018'},
      }
    }
 */

export default (getChecker) => (featureName, checkers) => (locals) => {
  checkers = toPairs(checkers);

  return !checkers.some(([checkerName, args]) =>
    getChecker(checkerName)(featureName, args)(locals),
  );
};
